import React from 'react'

import Question from './Question'

const Builder = ({
  questions = [],
  setAnswer,
  disableQuestions,
  validating,
  scope,
}) =>
  questions.map(i => (
    <Question
      disabled={disableQuestions}
      key={i.id}
      scope={scope}
      question={i}
      validating={validating}
      setAnswer={setAnswer(i.id)}
    />
  ))

export default Builder
